// src/App.js
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import Header from "./components/header";
import CompaniesVIPSales from "./pages/companiesVIPSales";
import JoinUs from "./pages/joinUs";
import Ambassadors from "./pages/ambassadors";
import Warranty from "./pages/warranty";
import Customer from "./pages/customer";
import Branches from "./pages/branches/Branches";

import {
  getBrand,           // Host → brand name (e.g., "Zyros")
  getBrandConfig,     // Brand → config from brands.json
  getHomePageUrl, // Brand → https://<domain>
  isBranchesSubdomain     
} from "./brandResolver";

// Small helper component for external redirects
function RedirectToExternal({ to }) {
  useEffect(() => {
    if (to) window.location.href = to;
  }, [to]);
  return null;
}

export default function App({ brand: brandProp }) {
  // Use brand passed from index.js, or derive here if not provided
  const brand = brandProp || getBrand();
  const cfg = getBrandConfig(brand);
  const homePage = getHomePageUrl(brand);
  const isBranches = isBranchesSubdomain();

  // branches.zyros.com
  if (isBranches) {
    return (
      <div className="App">
        <Header brand={brand} cfg={cfg} variant="branches" />
        <Branches />
      </div>
    );
  }


  return (
    <div className="App">
      {/* If your Header can accept props, pass them; otherwise it can import brandResolver itself */}
      <Header brand={brand} cfg={cfg} />

      <Routes>
        {/* Hit "/" → send user to the brand homepage (external) */}
        <Route path="/" element={<RedirectToExternal to={homePage} />} />

        {/* Your internal pages */}
        <Route path="/joinUS" element={<JoinUs />} />
        <Route path="/CompaniesVIPSales" element={<CompaniesVIPSales />} />
        <Route path="/Ambassadors" element={<Ambassadors />} />
        <Route path="/Warranty" element={<Warranty />} />
         <Route path="/Customer" element={<Customer />} />
      </Routes>
    </div>
  );
}
